import { render } from "./IssueCardFoldable.vue?vue&type=template&id=faf7a9f6"
import script from "./IssueCardFoldable.vue?vue&type=script&lang=js"
export * from "./IssueCardFoldable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__